import { MenuItem, TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoDetalleConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoDetalleConsultaGeneral';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';

import useStyles from '../tablaDetallesPlantillaEstilos';
import Autocomplete from '@material-ui/lab/Autocomplete';

interface ICampoDivisionDestinoProps {
    deshabilitado: boolean;
    detalle: IDocumentoDetalleConsultaGeneral;
    divisiones: IBodegaDivisiones[];
    manejarCambioCampo: (
        detalleId: string,
        nombreCampo: keyof IDocumentoDetalleConsultaGeneral,
        nuevoValor: any
    ) => void;
    esRequerido:boolean;
}

const CampoDivisionDestino: FunctionComponent<ICampoDivisionDestinoProps> = ({
    deshabilitado,
    detalle,
    divisiones,
    manejarCambioCampo,
    esRequerido
}) => {
    const classes = useStyles();

    return (
        <Autocomplete
            options={divisiones}
            getOptionLabel={(option) => option.DivisionDescripcion}
            value={divisiones.find((division) => division.DivisionId === detalle.DivisionDestino) || null}
            onChange={(event, newValue) => {
                manejarCambioCampo(
                    detalle.DocumentoDetalleId,
                    'DivisionDestino',
                    newValue ? newValue.DivisionId : ''
                );
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={<Texto id="TablaDetallesPlantilla.DivisionDestino" />}
                    fullWidth
                    size="small"
                    required={esRequerido}
                    disabled={deshabilitado}
                    classes={{ root: classes.campo }}
                />
            )}
        />
    );
};

export default CampoDivisionDestino;
